import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Alert, Card, Tag } from "antd";
import "./paymentStatus.scss";

import { resultPayment } from "../../../apis/result";
import moment from "moment";
import { AppContext } from "../../../App";
import { TIME_FORMAT } from "../../../utils/constants";
import PaymentStatusTemplate from "../../../components/paymentStatusTemplate/paymentStatusTemplate";

function PaymentStatusPage() {
  const [data, setData] = useState({});
  const { setLoading } = useContext(AppContext);
  const { pid } = useParams();

  useEffect(() => {
    getApplicationResultPayment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getApplicationResultPayment = async () => {
    setLoading(true);
    try {
      const res = await resultPayment();
      if (res.error) {
        throw new Error(`${res.error.msgCode} - ${res.error.message}`);
      } else {
        setData(res);
      }
    } catch (e) {
      // console.log(e)
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="payment-status-page">
      <PaymentStatusTemplate
        pid={pid}
        id={data.applicationNumber}
        canEdit={false}
        paymentData={data}
      />

      <Alert
        message="繳費狀態更新需要數個工作天。請留意你是否已繳費，以免重覆付款。如有問題請聯絡我們"
        type="error"
      />
    </div>
  );
}

export default PaymentStatusPage;
